<template>
    <div class="tagPage" v-wechat-title="this.title">
        <div style="width: 103%;box-sizing: border-box;overflow-y: scroll;overflow-x: hidden;-webkit-overflow-scrolling: auto;"  ref="wrapper" :style="{ height: (wrapperHeight) + 'px' }">
            <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" bottomPullText="" bottomDropText="正在加载" ref="loadmore" :auto-fill="false">
                <div class="title">
                    <img src="../../assets/topic_icon.png">
                    <span>{{topic}}</span>
                </div>
                <div class="alltopicList">
                    <div class="oneTopic" v-for="onetopic in topicList" :key="onetopic.id">
                        <div class="header">
                            <div class="left">
                                <div class="pic">
                                    <img :src="onetopic.avatar" alt="">
                                </div>
                                <div class="nameAndwh">
                                    <div>
                                        <p class="name">{{onetopic.name}}</p>
                                        <img style="width:0.64rem;height:0.3rem;margin-left:0.14rem;display:inline-block;margin-top:0.48rem;" src="../../assets/label_user@2x.png" v-if="onetopic.is_host != '1'" alt="">
                                        <img style="width:0.84rem;height:0.3rem;margin-left:0.14rem;display:inline-block;margin-top:0.48rem;" src="../../assets/label_host@2x.png" v-if="onetopic.is_host == '1'" alt="">
                                    </div>
                                    <p class="radio">{{onetopic.title}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <p v-html="onetopic.content">
                                <!-- <span v-html="onetopic.first"></span>
                                <span class="heightLight" v-html="onetopic.sec"></span>
                                <span v-html="onetopic.three"></span> -->
                            </p>
                            <div class="imgDiv" v-if="onetopic.image.length>0" :class="{oneFather:onetopic.image.length == '1'}">
                                <img v-for="oneImg in onetopic.image" :key="oneImg.id" :src="oneImg.img" alt="" :class="{rightImg:oneImg.addClass == 'right'}">
                            </div>
                            <div class="videoDiv" v-if="onetopic.video!=''">
                                <img :src="onetopic.cover" alt="" @click="showVideos(onetopic.video,onetopic.cover)">
                                <img src="../../assets/play.png" class="play" alt="" @click="showVideos(onetopic.video,onetopic.cover)">
                            </div>
                        </div>
                        <div class="bottom">
                            <span class="timeShow">
                                {{onetopic.time|time}}
                            </span>
                            <div class="pin">
                                <img src="../../assets/icon_message@2x.png" alt="">
                                <span>{{onetopic.comment}}</span>
                            </div>
                            <div class="zan">
                                <img src="../../assets/icon_like@2x.png" alt="">
                                <span>{{onetopic.star}}</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="zhanwei" v-show="iskong == '1'">
                    <p>
                    <img src="../../assets/kong1.png" alt="">   
                    </p>
                    <p style="font-weight:400;color:rgba(189,195,206,1);font-size:0.28rem;margin-bottom: 0.3rem;">
                        空空如也~
                    </p>
                </div>
                <div v-if="allLoaded && iskong!='1'" style="text-align:center;margin-bottom:0.1rem;padding-bottom: 0.2rem;padding-top: 0.2rem;color: rgb(189, 195, 206);" >我们是有底线的</div>
            </mt-loadmore>
            <!-- <div >已经到底了</div> -->
            <div style="height:1.4rem;"></div>
        </div>
        <div class="video" v-show="videoShow == '1'">
            
            <video id="videoid" preload="auto" webkit-playsinline="" playsinline="" x-webkit-airplay="allow" x5-video-orientation="landscape|portrait" x5-mse-live-streaming="" :src="videoSrc" style="width: 100%; height: 100%; object-fit: fill;"></video>
        </div>
        <div class="bottomDiv">
            <div class="left">
                <img src="../../assets/logo.png" alt="">
                <div class="word">
                    <p>下载听见广播App</p>
                    <p class="lowLight">参与话题讨论！</p>
                </div>
            </div>
            <div class="right">
                <img src="../../assets/btn_download@2x.png" alt="" @click="toDownloadpage">
            </div>
        </div>
        <toast :msg="msg" ></toast>
    </div>
</template>
<script>
    import cbct from '../../../static/js/base.js'
    import toast from '../commen/toast.vue'
    import { Loadmore } from 'mint-ui'; 
    import qs from 'qs';
    import share from '../../../static/js/share.js';
    export default {
        name: 'tagPage',
        props: {
            
        },
        data(){
            return { 
                msg:'',
                tid:'',
                page:1,
                topic:'',
                title:'话题分享',
                allLoaded:false,//是否加载完毕
                haveMore:true,//是否有更多数据
                scrollMode:'auto',
                topStatus: '',//顶部下拉加载状态
                bottomStatus: '',//底部上拉加载状态
                wrapperHeight:0,
                //数据展示
                topicList:[],
                videoSrc:'',
                videoShow:'',
                iskong:'',
            }
        },
        filters:{
            time:function(time){
                var nowTime = Number(Date.parse(new Date()))/1000;
                var timeC = Number(nowTime - time);
                var timeCC = '';
                if(cbct.timestampToTimes(time) == '昨天'){
                    timeCC = '昨天'+cbct.timestampToTime(time);
                }else if(cbct.timestampToTimes(time) == '前天'){
                    timeCC = '前天'+cbct.timestampToTime(time);
                }else if(cbct.timestampToTimes(time) == 'no'){
                    if(timeC<(3600*24*7)){
                        timeCC = cbct.getWeek(time) + cbct.timestampToTime(time);
                    }
                    else if((3600*24*7)<=timeC){
                        timeCC = cbct.timestampToTime(time);
                    }
                }else{
                    if(timeC<60){
                        timeCC = '刚刚';
                    }else if(60<timeC && timeC<Number(3600)){
                        timeCC = parseInt(timeC/60)+'分钟前';
                    }else if(3600<=timeC&& timeC <(3600*24)){
                        timeCC = cbct.timestampToTime(time);
                    }
                }
                return timeCC;
            }
        },
        created(){
            let self = this;
            if(self.$route.query.tid){
                self.tid=self.$route.query.tid;
            }else{
                // self.bus.$emit('toast',{show:true,title:'参数错误'})
            }
            this.getData();
            share.share(this,window.location.href,'可听、可看、可聊的广播里，主持人在等你来撩~','听见广播，看见美好声音','https://seefm.oss-cn-beijing.aliyuncs.com/image/share_pic_topic.jpg','可听、可看、可聊的广播里，主持人在等你来撩~');
            share.QQshare(window.location.href,'可听、可看、可聊的广播里，主持人在等你来撩~','听见广播，看见美好声音','https://seefm.oss-cn-beijing.aliyuncs.com/image/share_pic_topic.jpg');
        },
        mounted(){
            this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
        },
        methods:{
            showVideos:function(url,img){
                this.$router.push({path:'./playPage?playUrl='+url+'&cover='+img });    
            },
            getData:function(){
                var self = this;
                self.$api.get(cbct.baseurl+'share/topic-moment-lists?tid='+this.tid+'&page='+this.page+'&pageSize=12', qs.stringify({
                })).then((response)=>{
                    if(response.c == cbct.code.successCode){  
                        self.topic = response.d.topic;
                        // if(response.d.list == 0){
                        //     self.bus.$emit('toast',{show:true,title:'话题已删除'});
                        // }
                        var topic = '#'+response.d.topic+'#';
                        for(var i=0;i<response.d.list.length;i++){
                            if(response.d.list[i].image){
                                for(var j=0;j<response.d.list[i].image.length;j++){
                                    response.d.list[i].image[j].img = cbct.imgUrl()+response.d.list[i].image[j].img;
                                    if((j+1)%3 == '0'){
                                        this.$set(response.d.list[i].image[j],'addClass','right');
                                    }
                                }
                            }
                            response.d.list[i].content = response.d.list[i].content;
                            response.d.list[i].avatar = cbct.imgUrlAvatar()+response.d.list[i].avatar;
                            var a = response.d.list[i].content.split(topic)[0];
                            var b =  response.d.list[i].content.split(topic)[1];
                            this.$set(response.d.list[i],'first',a);
                            if(response.d.list[i].content.indexOf(response.d.topic)!= '-1'){
                                this.$set(response.d.list[i],'sec',topic);
                            }else{
                                this.$set(response.d.list[i],'sec','');
                            }
                            
                            this.$set(response.d.list[i],'three',b);
                            if(response.d.list[i].content.indexOf(topic) != '-1'){
                                response.d.list[i].content = a.replace(/\n/g,'<br>')+'<span class="heightLight" style="color: rgba(255, 195, 22, 1)">'+topic.replace(/\n/g,'<br>')+'</span>'+b.replace(/\n/g,'<br>');
                            }else{
                                if(a != undefined && b != undefined){
                                    // console.log(a);
                                    // console.log(b);
                                    response.d.list[i].content = a.replace(/\n/g,'<br>')+b.replace(/\n/g,'<br>');
                                }
                                if(a == undefined && b != undefined){
                                    response.d.list[i].content = b.replace(/\n/g,'<br>');
                                }
                                if(a != undefined && b == undefined){
                                    response.d.list[i].content = a.replace(/\n/g,'<br>');
                                }
                                if(a == undefined && b == undefined){
                                    response.d.list[i].content = undefined;
                                }
                                
                            }
                            
                            if(String(response.d.list[i].star).length>=5){
                                response.d.list[i].star = (Number(response.d.list[i].star)/10000).toFixed(1) +'w';
                            }
                            if(String(response.d.list[i].is_follow).length>=5){
                                response.d.list[i].is_follow = (Number(response.d.list[i].is_follow)/10000).toFixed(1) +'w';
                            }
                        }
                        if(response.d.list.length == '0' && this.page != '1'){
                            this.haveMore=false;
                            this.allLoaded=false;
                            this.ishaveMore();
                        }
                        if(response.d.list.length == '0' && this.page == '1'){
                            this.iskong = '1';
                            self.bus.$emit('toast',{show:true,title:'话题已删除'});
                        }
                        if(this.page == '1' && response.d.list.length > '0'){
                            self.topicList = response.d.list;
                            this.iskong = '';
                        }else{
                            self.topicList = self.topicList.concat(response.d.list);
                        }
                        // self.titlt = '123';
                        
                       
                       
                    }else if(response.c == cbct.code.noLogin){
                        self.bus.$emit('toast',{show:true,title:response.m})
                    }else if(response.c == cbct.code.raleNoLogin){
                        self.bus.$emit('toast',{show:true,title:response.m})          
                    }else{
                        self.bus.$emit('toast',{show:true,title:response.m})
                    }                    
                }
                ).catch((error)=>{console.log(error);})	  
            },
            //下拉刷新
            loadTop:function(){
                this.page=1;
                let self=this;
                self.getData();
                self.allLoaded = false;
                this.$refs.loadmore.onTopLoaded();//固定方法 查询完调用用于重新定位  
            },
            more(){
                this.page=parseInt(this.page)+1;
                let self=this;
                self.getData();
            },
            loadBottom:function(){//上拉加载
                if (!this.allLoaded) {
                    this.page+=1;
                    let self =this;
                    self.getData();
                    this.$refs.loadmore.onBottomLoaded();
                }else{
                    this.allLoaded=true;
                }
            },
            ishaveMore:function(){
                this.allLoaded=true;
                if (this.haveMore) {
                    this.allLoaded=false;
                }
            },
            toDownloadpage(){//点击下载
                this.$router.push({path:"downloadApp?isFrom=programRecorded"});
            },
            

        },
        components: {
            toast,
        }
        
    }
</script>
<style scoped lang="scss">
    .tagPage{
        position: absolute;
        width: 100%;
        // box-sizing: border-box;
        overflow: hidden;
        height:100%;
        font-size: 0.24rem;
        .zhanwei{
            margin: 0 auto;
            margin-top: 3rem;
            margin-bottom: 3rem;
            // background:rgba(248,248,248,1);
            img{
                width: 2.8rem;
                margin-bottom: 0.3rem;
            }
            .heKnow{
                    span{
                    display: inline-block;
                    width: 2.36rem;
                    height: 0.68rem;
                    line-height: 0.68rem;
                    border-radius: 0.59rem;
                    border:solid 1px rgba(204,50,50,1);
                    color: rgba(204,50,50,1);
                    margin-bottom: 0.4rem;
                    margin-top: 0.2rem;
                }
            }

        }
        .title{
            width: 100%;
            height: auto;
            overflow: hidden;
            border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
            img{
                float: left;
                width: 0.44rem;
                margin: 0.21rem 0 0.21rem 0.3rem;
                height: 0.44rem;
            }
            span{
                text-align: left;
                float: left;
                font-size: 0.36rem;
                line-height: 1;
                padding: 0.28rem 0.3rem 0.1rem 0.1rem;
                color: rgba(0, 0, 0, 0.85);
                width: 6.36rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .alltopicList{
            margin-left: 0.3rem;
            margin-right: 0.3rem;
            width: 6.9rem;
            height: auto;
            .oneTopic{
                width: 100%;
                height: auto;
                overflow: hidden;
                border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
                .header{
                    width: 100%;
                    height: 1.6rem;
                    overflow: hidden;
                    .left{
                        float: left;
                        width: auto;
                        height: 100%;
                        .pic{
                            float: left;
                            width: auto;
                            height: 100%;
                            margin-right: 0.18rem;
                            img{
                                width: 0.8rem;
                                height: 0.8ren;
                                border-radius: 50%;
                                margin-top: 0.4rem;
                            }
                        }
                        .nameAndwh{
                            width: auto;
                            height: 100%;
                            float: left;
                            div{
                                width: auto;
                                height: auto;
                                overflow: hidden;
                                .name{
                                    float: left;
                                    font-size: 0.26rem;
                                    color: rgba(0, 0, 0, 1);
                                    margin-top: 0.49rem;
                                    line-height: 1;
                                    margin-bottom: 0.09rem;
                                }
                            }
                            .radio{
                                text-align: left;
                                font-size: 0.24rem;
                                color: #acb1c0;
                                line-height: 1;
                            }
                        }
                    }
                    .right{
                        float: right;
                        width: auto;
                        height: 100%;
                        img{
                            float: right;
                            margin-top: 0.52rem;
                            width: 1.17rem;
                            height: 0.56rem;
                        }
                    }
                }
                .content{
                    width: 100%;
                    height: auto;
                    overflow: hidden;
                    p{
                        width: 100%;
                        height: auto;
                        text-align: left;
                        overflow: hidden;
                        float: left;
                        font-size: 0.28rem;
                        line-height: 0.42rem;
                        color: #000;
                        word-break:break-all;
                        .heightLight{
                            color: rgba(255, 195, 22, 1);
                        }
                    }
                    .imgDiv{
                        width: 100%;
                        height: auto;
                        overflow: hidden;
                        margin: 0.2rem 0;
                        img{
                            border-radius: 0.05rem;
                            float: left;
                            width: 2.22rem;
                            height: 2.22rem;
                            margin-right: 0.12rem;
                            margin-bottom: 0.1rem;
                        }
                        .rightImg{
                            margin-right: 0;
                        }
                    }
                    .videoDiv{
                        width: 100%;
                        height: auto;
                        overflow: hidden;
                        margin: 0.1rem 0;
                        position: relative;
                        img{
                            float: left;
                            width: 3.2rem;
                            height: 3.2rem;
                        }
                        .play{
                            width: 0.6rem;
                            height: 0.6rem;
                            left: 1.2rem;
                            position: absolute;
                            top: 1.2rem;
                        }
                    }
                    .oneFather{
                        img{
                            width: 3.6rem;
                            height: 3.6rem;
                        }
                    }

                }
                .bottom{
                    width: 100%;
                    height: auto;                   
                    overflow: hidden;                    
                    .timeShow{
                        margin-top: 0.45rem;
                        margin-bottom: 0.53rem;
                        float: left;
                        font-size: 0.24rem;
                        color: rgba(172, 177, 192, 1);
                        line-height: 1;
                    }
                    .zan,.pin{
                        float: right;
                        img{
                            float: left;
                            width: 0.44rem;
                            height: 0.44rem;
                            margin: 0.4rem 0 0.41rem 0;
                        }
                        span{
                            float: left;
                            font-size: 0.24rem;
                            color: rgba(0, 0, 0, 1);
                            margin: 0.5rem 0 0.51rem 0.1rem;
                        }
                    }
                    .zan{
                        span{
                            margin-right: 0.23rem;
                        }
                    }
                }
            }
        }
        .bottomDiv{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 1.4rem;
            background: rgba(0, 0, 0, 0.8);
            .left{
                float: left;
                width: auto;
                height: 1.4rem;
                img{
                    float: left;
                    width: 0.88rem;
                    height: 0.88rem;
                    margin: 0.26rem 0 0.26rem 0.3rem;
                }
                div{
                    float: left;
                    margin-left: 0.16rem;
                    height: 100%;
                    p{
                        font-size: 0.28rem;
                        margin: 0.35rem 0 0.2rem 0;
                        color: rgba(255, 255, 255, 1);
                        line-height: 1;
                    }
                    .lowLight{
                        text-align: left;
                        margin: 0;
                        color: rgba(153, 153, 153, 1);
                        font-size: 0.24rem;
                        line-height: 1;
                    }
                }
            }
            .right{
                float: right;
                width: auto;
                height: 100%;
                overflow: hidden;
                img{
                    width: 1.76rem;
                    height: 0.68rem;
                    margin: 0.36rem 0.3rem;
                }
            }
        }
    }
</style>
